module.exports = __webpack_public_path__ + "img/Icon-email-log.69a20a82.svg";